import { LitElement, html, css, unsafeCSS } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { getTheme, setTheme, type Theme } from '../utils/theme.js'
import { t } from '../utils/i18n.js'
import styles from './theme-toggle.css?inline'

/**
 * Theme toggle component
 * Switches between light (cappuccino) and dark (tobacco) modes
 */
@customElement('theme-toggle')
export class ThemeToggle extends LitElement {
  @state()
  private currentTheme: Theme = getTheme()

  static styles = css`${unsafeCSS(styles)}`

  connectedCallback() {
    super.connectedCallback()
    // Listen for theme changes from other components
    window.addEventListener('themechange', () => {
      this.currentTheme = getTheme()
      this.requestUpdate()
    })
    // Listen for i18n updates
    window.addEventListener('i18n-updated', () => {
      this.requestUpdate()
    })
  }

  private toggleTheme() {
    const newTheme: Theme = this.currentTheme === 'light' ? 'dark' : 'light'
    setTheme(newTheme)
    this.currentTheme = newTheme
    
    // Dispatch event for other components
    window.dispatchEvent(new CustomEvent('themechange'))
  }

  render() {
    return html`
      <button @click=${this.toggleTheme} title=${t('theme.toggleTitle')}>
        <span class="icon">${this.currentTheme === 'light' ? '🌙' : '☀️'}</span>
        <span>${this.currentTheme === 'light' ? t('theme.dark') : t('theme.light')}</span>
      </button>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'theme-toggle': ThemeToggle
  }
}
